import { useState, useEffect } from "react";
import { Menu, X, Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.jpg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Top Red Emergency Banner */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-destructive text-white">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between text-sm md:text-base">
            {/* Urgence 24h/24 */}
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 md:h-5 md:w-5" />
              <span className="font-semibold">URGENCE 24H/24</span>
            </div>
            
            {/* Téléphone (clickable) */}
            <a href="tel:0766009189" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Phone className="h-4 w-4 md:h-5 md:w-5" />
              <span className="font-bold">07 66 00 91 89</span>
            </a>
            
            {/* Intervention rapide */}
            <div className="hidden md:block">
              <span>Intervention en moins de 30 min</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className={`fixed top-12 left-0 right-0 z-40 transition-all duration-300 bg-white shadow-md`}>
        <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="Tolstoï Serrurier" className="h-16 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-secondary hover:text-primary transition-colors font-medium">
              Accueil
            </Link>
            <Link to="/depannage-urgence" className="text-secondary hover:text-primary transition-colors font-medium">
              Dépannage urgence
            </Link>
            <div className="relative group">
              <button className="text-secondary hover:text-primary transition-colors font-medium">
                Services
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-lg rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <Link to="/ouverture-porte" className="block px-4 py-3 text-secondary hover:bg-muted transition-colors">Ouverture de porte</Link>
                <Link to="/changement-serrure" className="block px-4 py-3 text-secondary hover:bg-muted transition-colors">Changement de serrure</Link>
                <Link to="/reparation-serrure" className="block px-4 py-3 text-secondary hover:bg-muted transition-colors">Réparation de serrure</Link>
                <Link to="/volet-roulant" className="block px-4 py-3 text-secondary hover:bg-muted transition-colors">Volet roulant</Link>
                <Link to="/porte-blindee-garage" className="block px-4 py-3 text-secondary hover:bg-muted transition-colors">Porte blindée & garage</Link>
              </div>
            </div>
            <Link to="/zones-intervention" className="text-secondary hover:text-primary transition-colors font-medium">
              Zone 69/01
            </Link>
            <Link to="/contact" className="text-secondary hover:text-primary transition-colors font-medium">
              Contact
            </Link>
          </nav>

          <Button variant="default" size="lg" className="hidden lg:flex gap-2" asChild>
            <a href="tel:0766009189">
              <Phone className="h-5 w-5" />
              07 66 00 91 89
            </a>
          </Button>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-secondary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4 animate-in slide-in-from-top bg-white">
            <Link to="/" className="block py-3 text-secondary hover:text-primary transition-colors">
              Accueil
            </Link>
            <Link to="/depannage-urgence" className="block py-3 text-secondary hover:text-primary transition-colors">
              Dépannage urgence
            </Link>
            <div className="py-3">
              <p className="font-semibold text-secondary mb-2">Services</p>
              <Link to="/ouverture-porte" className="block py-2 pl-4 text-secondary/80 hover:text-primary transition-colors">Ouverture de porte</Link>
              <Link to="/changement-serrure" className="block py-2 pl-4 text-secondary/80 hover:text-primary transition-colors">Changement de serrure</Link>
              <Link to="/reparation-serrure" className="block py-2 pl-4 text-secondary/80 hover:text-primary transition-colors">Réparation de serrure</Link>
              <Link to="/volet-roulant" className="block py-2 pl-4 text-secondary/80 hover:text-primary transition-colors">Volet roulant</Link>
              <Link to="/porte-blindee-garage" className="block py-2 pl-4 text-secondary/80 hover:text-primary transition-colors">Porte blindée & garage</Link>
            </div>
            <Link to="/zones-intervention" className="block py-3 text-secondary hover:text-primary transition-colors">
              Zone 69/01
            </Link>
            <Link to="/contact" className="block py-3 text-secondary hover:text-primary transition-colors">
              Contact
            </Link>
            <Button variant="default" size="lg" className="w-full mt-4 gap-2" asChild>
              <a href="tel:0766009189">
                <Phone className="h-5 w-5" />
                07 66 00 91 89
              </a>
            </Button>
          </nav>
        )}
      </div>
    </header>
    </>
  );
};

export default Header;
